import { ObjID } from './object-id.interface';
import { Point } from '@angular/cdk/drag-drop';
import { BehaviorSubject, Observable } from 'rxjs';
import { PortType } from './node-models.interface';

export interface BandData {
	srcId: ObjID;
	destId: ObjID;
	type: BandType;
}

export interface BandEditEvent extends BandData {
	portType: PortType;
	mouseEvent: MouseEvent;
}

export interface BandEditTouchEvent extends BandData {
	portType: PortType;
	touchEvent: TouchEvent;
	touchPosition$: Observable<TouchEvent>;
}

export interface BandState {
	destId: ObjID;
	type$: BehaviorSubject<BandType>;
	position$?: BehaviorSubject<BandCoordinates>;
}

export type NewRenderBandMessage = {
	srcId?: ObjID;
	destId?: ObjID;
	type$: Observable<BandType>;
	position$: Observable<BandCoordinates>;
	temporaryType: TemporaryBandType;
	selectOnInit: boolean;
};

export enum BandType {
	success,
	failure,
}

export interface BandCoordinates {
	srcPos: Point;
	destPos: Point;
}

export enum TemporaryBandType {
	none,
	inputAnchor,
	outputAnchor,
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
